import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

const slider= () => {
    const el = document.querySelector('.js-swiper');
    if (!el) return;

    new Swiper(el, {
        modules: [Pagination],

        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });
}
const swiper = () => {
    slider();
}

export default swiper;
